<div class="modal-header">
  <h5 class="modal-title">{{'REGISTER.CONSENT_TITLE' | translate }}</h5>
</div>

<div class="modal-b">
  <div *ngIf="loading" class="text-center">
    <div class="spinner-border spinner-border-sm" role="status"></div>
  </div>

  <div *ngIf="!loading">
    <!-- Dynamic consents from API -->
    <div class="form-group" *ngFor="let consent of missingConsents">
      <div class="custom-control custom-checkbox">
        <input class="custom-control-input" type="checkbox" [(ngModel)]="consentChecked[consent.id]" [id]="'consent-' + consent.id" />
        <label class="custom-control-label" [for]="'consent-' + consent.id">
          {{getConsentAgreementLabel(consent.consentType) | translate}} <a (click)="openNewTab(consent.content)" href="javascript:void(0)" class="c-company">{{getConsentLabel(consent.consentType) | translate}}</a>
        </label>
      </div>
    </div>

    <!-- Email register for pepsi -->
    <div class="form-group" *ngIf="shouldEmailBeChanged()">
      <label class="form-label" for="emailInput">{{
          ('LOGIN.EMAIL_LABEL' | translate)
        }}</label>
      <input
        id="emailInput"
        class="form-control"
        type="email"
        [(ngModel)]="email"
        name="email"
        required
        #emailCtrl="ngModel"
      />

      <div class="error" *ngIf="(emailCtrl.touched && emailCtrl.invalid) || emailError">
      <span *ngIf="emailCtrl.errors?.['required']">
        {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
      </span>
        <span *ngIf="emailError">
        {{ 'LOGIN.EMAIL_WRONG' | translate }}
      </span>
      </div>
    </div>

    <div class="d-flex buttons">
      <button class="btn-primary mr-2" [disabled]="!allConsentsChecked" (click)="closeBtnClick(true)">
        <span class="ficon feather icon-check-square"></span>
        {{ 'REGISTER.CONSENT_AGREE' | translate }}
      </button>

      <button class="btn-secondary" (click)="closeBtnClick(false)">
        <span class="ficon feather icon-square"></span>
        {{ 'REGISTER.CONSENT_DENY' | translate }}
      </button>
    </div>
  </div>
</div>
